import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface MarkAllAttendanceParam {
  classId: string;
  date: string;
  markAllType: 'present' | 'absent';
}

export const markAllAttendanceAPI = async (params: MarkAllAttendanceParam) => {
  const apiEndpoint =
    params.markAllType === 'present'
      ? '/attendance/mark-all-present'
      : '/attendance/mark-all-absent';

  const resp = await baseAPI.post<unknown>(apiEndpoint, {
    classId: params.classId,
    date: params.date,
  });
  return resp.data;
};

export const useMarkAllAttendanceMutation = () => {
  return useMutation({
    mutationFn: async (params: MarkAllAttendanceParam) => {
      const response = await markAllAttendanceAPI(params);
      return response;
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ATTENDANCE, variables.classId, variables.date],
      });
    },
    onSettled: (_, __, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ATTENDANCE, variables.classId, variables.date],
      });
    },
  });
};
